import { LitElement, html } from "lit-element";
import { store } from "@stofloos/stores/store";
import { initRequest } from "@stofloos/actions/requests";
import { clearForm, formToJSON, getFormElements, validateForm } from "@stofloos/utils/sw-constants";
import { createObject } from "@stofloos/actions/crud";
import { showToast } from "@stofloos/actions/toast";
import { localize } from "@stofloos/actions/localize";
import { changePage } from "@stofloos/actions/app";

import "@stofloos/components/atoms/loaders/sw-fullscreen-spinner";

export class ButtonSubmit extends LitElement {
	static get properties() {
		return {
			label: { type: String },
			formElement: { type: Object },
			endpoint: { type: String },
			callback: { type: Object },
			id: { type: String },
			data: { type: Object },
			disabled: { type: Boolean },
			isLoading: { type: Boolean }
		};
	}

	constructor() {
		super();
	}

	render() {
		return html`
			<sw-fullscreen-spinner ?active="${this.isLoading}"></sw-fullscreen-spinner>

			<button-contained
				label="${this.label}"
				?disabled="${this.isLoading}"
				@click="${() => this.createObject()}"
			></button-contained>
		`;
	}

	createObject() {
		const form = this.formElement.querySelector("form");
		const formElements = getFormElements(form);

		if (!validateForm(formElements)) {
			return;
		}

		const data = formToJSON(formElements);

		this.isLoading = true;
		store
			.dispatch(createObject(this.requestId, data))
			.then(response => {
				this.isLoading = false;
				store.dispatch(showToast(this.callback.message.success));
				store.dispatch(changePage(this.callback.url));
				clearForm(formElements);
			})
			.catch(response => {
				this.isLoading = false;
				store.dispatch(showToast(this.callback.message.error));
			});
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);

		this.requestId = this.endpoint;
		store.dispatch(initRequest(this.requestId, this.endpoint));
	}
}

customElements.define("button-submit", ButtonSubmit);
